import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MyCooperativeCard } from "../../../components/cards/myCooperativeCard";
import { SearchInput } from "../../../components/inputs/searchInput";
import { CoopCardLoader } from "../../../components/loaders/coopCardLoader";
import { AwaitingMembershipApprovalModal } from "../../../components/modals/app_modals/awaitingMembershipApprovalModal";
import { TableComponent } from "../../../components/table/table";
import { PageTitle } from "../../../components/typography/pageTitle";
import { useModalControl } from "../../../customHooks/useModalControl";
import { useGetUserCooperativesQuery } from "../../../redux/features/cooperative/cooperative.api";
import { SingleCooperativeMember } from "../../../redux/features/cooperative/cooperative.type";
import { QueryProps } from "../../../utils/types";

export const MyCooperatives = () => {
  const [query, setQuery] = useState<QueryProps>({
    offset: 0,
    limit: 10,
    text: undefined,
  });
  const [selectedData, setSelectedData] = useState<SingleCooperativeMember>();

  const navigate = useNavigate();

  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  const { data: userCooperatives, isLoading: fetchingUserCooperatives } =
    useGetUserCooperativesQuery(query, {
      refetchOnMountOrArgChange: true,
    });

  return (
    <div className="w-full min-h-full flex flex-col gap-6">
      <PageTitle
        text="My Cooperatives"
        subtext="Manage your cooperatives all in one place"
        containerClassName="max-md:hidden"
      />

      <SearchInput
        placeholder="Search cooperative name"
        searchFunction={(val) => {
          setQuery({ ...query, text: val });
        }}
      />

      <TableComponent
        headers={[]}
        rowClassName="max-md:first:!pl-4 max-md:last:!pr-4"
        rows={
          userCooperatives?.data?.results?.map((entry, idx) => {
            return {
              id: `${idx}-${entry.Cooperative.id}`,
              items: [
                <MyCooperativeCard
                  memberData={entry}
                  key={`${entry.Cooperative.id}-approvals`}
                  handleClick={() => {
                    if (entry.isApprove) {
                      navigate(
                        `/app/my-cooperatives/${encodeURIComponent(
                          entry.Cooperative.CoopName
                        )}/${entry.Cooperative.id}`
                      );
                    } else {
                      setSelectedData(entry);
                      handleModalOpen("awaitingMembershipApprovalModal");
                    }
                  }}
                />,
              ],
            };
          }) ?? []
        }
        isTableEmpty={[0, undefined].includes(userCooperatives?.data?.count)}
        emptyTitle="No cooperatives found"
        emptySubTitle="You haven’t joined any yet, or try adjusting your search."
        emptrySrc="/assets/images/empty_state_cooperatives.svg"
        isLoading={fetchingUserCooperatives}
        loadingHeight={72}
        itemsPerPage={5}
        custLoader={<CoopCardLoader count={query.limit} />}
        className="!border-spacing-y-3"
      />

      {!!selectedData ? (
        <AwaitingMembershipApprovalModal
          modalOpen={modalOpen && modal === "awaitingMembershipApprovalModal"}
          onModalClose={() => {
            handleModalClose();
          }}
          memberDetails={selectedData}
        />
      ) : undefined}
    </div>
  );
};
